import React from "react";
import PageLayout from "./components/PageLayout";
import CreateDemoConversationView from "./components/CreateDemoConversationView";

function AppContent() {
  return (
    <PageLayout>
      <CreateDemoConversationView />
    </PageLayout>
  );
}

export default AppContent;
